/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Audit_Event_Nda_Signed_By_Gp14Inputs */

const en_coinvestments_audit_event_nda_signed_by_gp14 = /** @type {(inputs: Coinvestments_Audit_Event_Nda_Signed_By_Gp14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDA Signed by GP`)
};

/**
* | output |
* | --- |
* | "NDA Signed by GP" |
*
* @param {Coinvestments_Audit_Event_Nda_Signed_By_Gp14Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_audit_event_nda_signed_by_gp14 = /** @type {((inputs?: Coinvestments_Audit_Event_Nda_Signed_By_Gp14Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Audit_Event_Nda_Signed_By_Gp14Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_audit_event_nda_signed_by_gp14(inputs)
});
export { coinvestments_audit_event_nda_signed_by_gp14 as "coInvestments_audit_event_NDA_SIGNED_BY_GP" }